export const FETCH_DRIVERS_DATA = "FETCH_DRIVERS_DATA";
export const FETCH_DRIVERS_SUCCESS = "FETCH_DRIVERS_SUCCESS";
export const FETCH_DRIVERS_FAILURE = "FETCH_DRIVERS_FAILURE";

export const FETCH_DRIVERS_DETAILS_DATA = "FETCH_DRIVERS_DETAILS_DATA";
export const FETCH_DRIVERS_DETAILS_SUCCESS = "FETCH_DRIVERS_DETAILS_SUCCESS";
export const FETCH_DRIVERS_DETAILS_FAILURE = "FETCH_DRIVERS_DETAILS_FAILURE";